import _classCallCheck from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _getPrototypeOf from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { RepulseBase } from "./RepulseBase";
import { RepulseDiv } from "./RepulseDiv";
export var Repulse = /*#__PURE__*/function (_RepulseBase) {
  _inherits(Repulse, _RepulseBase);
  var _super = _createSuper(Repulse);
  function Repulse() {
    _classCallCheck(this, Repulse);
    return _super.apply(this, arguments);
  }
  _createClass(Repulse, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(Repulse.prototype), "load", this).call(this, data);
      if ((data === null || data === void 0 ? void 0 : data.divs) === undefined) {
        return;
      }
      if (data.divs instanceof Array) {
        this.divs = data.divs.map(function (s) {
          var tmp = new RepulseDiv();
          tmp.load(s);
          return tmp;
        });
      } else {
        if (this.divs instanceof Array || !this.divs) {
          this.divs = new RepulseDiv();
        }
        this.divs.load(data.divs);
      }
    }
  }]);
  return Repulse;
}(RepulseBase);